import { START_HOUR, END_HOUR, HOUR_HEIGHT } from './constants';

export function formatTime(hours, minutes) {
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

export function formatMinutes(totalMinutes) {
  return formatTime(Math.floor(totalMinutes / 60), totalMinutes % 60);
}

export function minutesToTop(totalMinutes) {
  return ((totalMinutes / 60) - START_HOUR) * HOUR_HEIGHT;
}

export function yToMinutes(offsetY) {
  const slots = Math.floor(offsetY / (HOUR_HEIGHT / 2));
  const totalMinutes = START_HOUR * 60 + slots * 30;
  const maxMinutes = (END_HOUR - 1) * 60;
  return Math.max(START_HOUR * 60, Math.min(totalMinutes, maxMinutes));
}

export function clampEndMinutes(endMinutes) {
  return Math.min(Math.max(endMinutes, START_HOUR * 60 + 30), END_HOUR * 60);
}

export function clampMoveStart(startMinutes, duration) {
  const minStart = START_HOUR * 60;
  const maxStart = Math.max(minStart, END_HOUR * 60 - duration);
  return Math.max(minStart, Math.min(startMinutes, maxStart));
}

export function yToEndMinutes(offsetY) {
  const dayHeight = (END_HOUR - START_HOUR) * HOUR_HEIGHT;
  // Snap to midnight when the pointer is near the bottom of the day column
  if (offsetY >= dayHeight - HOUR_HEIGHT / 4) {
    return END_HOUR * 60;
  }
  const slots = Math.ceil(Math.max(0, offsetY) / (HOUR_HEIGHT / 2));
  return Math.min(END_HOUR * 60, START_HOUR * 60 + slots * 30);
}

export function clampResizeEnd(startMinutes, endMinutes) {
  const minEnd = startMinutes + 30;
  const maxEnd = END_HOUR * 60;
  return Math.max(minEnd, Math.min(endMinutes, maxEnd));
}

export function rangeFromDrag(originMinutes, currentMinutes) {
  const start = Math.min(originMinutes, currentMinutes);
  let end = Math.max(originMinutes, currentMinutes) + 30;
  end = clampEndMinutes(end);
  if (end <= start) end = start + 30;
  return { start, end };
}

export function minutesToTimeValue(minutes) {
  // HTML <input type="time"> max is 23:59 (not 24:00)
  if (minutes >= 24 * 60) {
    return '23:59';
  }
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function timeValueToMinutes(value) {
  const [h, m] = String(value || '0:0').split(':').map(Number);
  const hours = Number.isFinite(h) ? h : 0;
  const mins = Number.isFinite(m) ? m : 0;
  // Treat 23:59 from the time picker as end-of-day (midnight) in the week grid
  if (hours === 23 && mins === 59) {
    return 24 * 60;
  }
  if (hours >= 24) {
    return 24 * 60;
  }
  return hours * 60 + mins;
}

export function eventHeight(start, end) {
  return Math.max(((end - start) / 60) * HOUR_HEIGHT, 30);
}
